/**
 * The one close (X) button look for every modal, taken from the Connect AI
 * provider modal: a quiet 32px rounded square that only shows a background
 * on hover. Position stays with each modal; this is just the look.
 *
 * Fallbacks matter: some modals portal outside the pages that define the
 * --hd-* tokens.
 */
export const modalCloseButton = `
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 10px;
  color: var(--hd-muted-foreground, #6b7080);
  background: transparent;
  backdrop-filter: none;
  box-shadow: none;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover:not(:disabled) {
    color: var(--hd-foreground, #1c1f2a);
    background: var(--hd-muted, #f2f3f5);
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
